import { Model } from "@tailflow/laravel-orion/lib/model";

export class ViewAppUrl extends Model<{
  name: string;
  created_at: string;
}> {
  public $resource(): string {
    return "campaigns";
  }
}
